import type { DialogOptions } from './use-dialog'
import type { FormProps } from '@el-plus/components/form'
import EpForm from '@el-plus/components/form'
import { createNameSpace } from '@el-plus/utils/bem'
import { useDialog } from './use-dialog'
import { nextTick, reactive, ref, toRaw } from 'vue'
const bem = createNameSpace('form-dialog')

type Options = {
  title?: string
  width?: string
  dialogProps?: DialogOptions
  formData?: FormProps['model']
  onBeforeConfirm?: (
    formData: FormProps['model'],
    resolve: (value: FormProps['model']) => void,
  ) => Promise<void>
  onBeforeCancel?: (
    formData: FormProps['model'],
    resolve: (value: string) => void,
  ) => Promise<void>
} & FormProps
export const useFormDialog = (options: Options = {}) => {
  const {
    dialogProps,
    title,
    width = '80%',
    onBeforeConfirm,
    onBeforeCancel,
    ...formProps
  } = options
  const formRef = ref()
  const isUseComFormData = !formProps.formData
  let formData
  const Dialog = useDialog({
    class: bem.b(),
    width,
    title,
    render: () => {
      formData = isUseComFormData ? reactive({}) : formProps.formData // eslint-disable-line
      return (
        <EpForm
          ref={formRef}
          v-model={formData}
          {...{
            col: 1,
            'label-width': 'auto',
            ...formProps,
          }}
        />
      )
    },
    onConfirm: async (resolve) => {
      await formRef.value.validate()
      if (onBeforeConfirm) {
        await onBeforeConfirm(formData, resolve)
      }
      return resolve(formData)
    },
    onCancel: async (resolve) => {
      if (onBeforeCancel) {
        await onBeforeCancel(formData, resolve)
      }
      resolve('cancel')
    },
    ...dialogProps,
  })
  const open = Dialog.open
  Dialog.open = async (...args) => {
    // 清除校验(fix: 不销毁且外面传递formData时, 再次打开校验不清除)
    if (!dialogProps?.destroyOnClose) {
      setTimeout(() => {
        formRef.value?.clearValidate()
      }, 0)
    }
    const res = await open(...args)
    return res
  }
  return Dialog
}
